import { useCallback } from 'react';
import { RadioGroup } from '@clds/radio';
import t from 'common/i18n';
import { useFilterParams } from '../../selectors';
import { LICENSE_TYPE_OPTIONS } from '../../filterConsts';
import { InlineFieldLayoutCustomized, Radio, RadioLabel, SectionBox } from './Filters.styles';

export default ({ handleSearch, source }) => {
  const { licenseType } = useFilterParams(source);
  const options = LICENSE_TYPE_OPTIONS.map((value) => ({ label: t(`${source}.filters.license.${value}`), value }));

  const filterChange = useCallback(
    (item) => {
      handleSearch({
        filters: {
          licenseType: item,
        },
      });
    },
    [handleSearch]
  );

  return (
    <SectionBox data-test="license-type-section">
      <label>{t(`${source}.filters.license.label`)}</label>
      <RadioGroup name="radio-group" value={licenseType} onChange={filterChange}>
        {options.map((item) => (
          <InlineFieldLayoutCustomized
            key={item.value}
            label={
              <RadioLabel htmlFor={item.value} data-test={item.value}>
                {item.label}
              </RadioLabel>
            }
          >
            <Radio id={item.value} value={item.value} />
          </InlineFieldLayoutCustomized>
        ))}
      </RadioGroup>
    </SectionBox>
  );
};
